import { lazy } from 'react';

const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem(
        'page-has-been-force-refreshed'
      ) || 'false'
    );

    try {
      const component = await componentImport();
      if (!component?.default) {
        // Chunk récupéré avec succès (pas d'échec réseau) mais résolu
        // après un déploiement vers un module sans export `default`
        // (hash de build différent). Même cause racine qu'un échec réseau
        // de chunk : on la traite donc comme telle (retry silencieux ci-
        // dessous, puis reload uniquement si ça échoue une 2e fois).
        const staleChunkError = new Error(
          'Loading chunk failed: resolved module has no default export'
        );
        staleChunkError.name = 'ChunkLoadError';
        throw staleChunkError;
      }
      window.localStorage.setItem(
        'page-has-been-force-refreshed',
        'false'
      );
      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        window.localStorage.setItem(
          'page-has-been-force-refreshed',
          'true'
        );
        return window.location.reload();
      }
      throw error;
    }
  });

export default lazyWithRetry;
